export default __webpack_public_path__ + "static/media/city_img_perth.798621ca.png";